import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmergencyMaterial, EmergencyMaterialClient, Material, Unit } from 'src/app/web-api-client';

@Component({
  selector: 'app-emergency-materials-form-select',
  templateUrl: './emergency-materials-form-select.component.html',
  styleUrl: './emergency-materials-form-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmergencyMaterialsFormSelectComponent {

  @Input() emergencyId: number;
  @Input() set availableMaterialsList(value: Material[]) {
    this._availableMaterialsList = value.slice();
  }
  @Input() set usedEmergencyMaterialsList(value: EmergencyMaterial[]) {
    this._usedEmergencyMaterialsList = value.slice();
  }
  @Input() unitsList: Unit[] = [];

  @Output() emergencyMaterialAdded = new EventEmitter<EmergencyMaterial>();
  @Output() emergencyMaterialDeleted = new EventEmitter<EmergencyMaterial>();
  @Output() emergencyMaterialsUpdated = new EventEmitter<EmergencyMaterial[]>();

  public _usedEmergencyMaterialsList: EmergencyMaterial[] = [];
  public _availableMaterialsList: Material[] = [];

  constructor(
    private readonly client: EmergencyMaterialClient,
    private toastr: ToastrService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  public getUnitTitle(unitId: number): string {
    return this.unitsList.find(u => u.id === unitId)?.title;
  }

  public onAddMaterialClicked(materialID: number) {
    const index = this._availableMaterialsList.findIndex(m => m.id === materialID);
    if (index > -1) {
      const material = this._availableMaterialsList[index];

      const emergencyMaterial = new EmergencyMaterial();
      emergencyMaterial.material = material;
      emergencyMaterial.materialId = material.id;
      emergencyMaterial.quantityUsed = 0;
      emergencyMaterial.emergencyId = this.emergencyId;


      this._availableMaterialsList.splice(index, 1);
      this._availableMaterialsList = this._availableMaterialsList.slice();

      this._usedEmergencyMaterialsList.push(emergencyMaterial);

      this.emergencyMaterialAdded.emit(emergencyMaterial);
      this.emergencyMaterialsUpdated.emit(this._usedEmergencyMaterialsList);

      this.changeDetectorRef.detectChanges();
    }
  }

  hasChanged(em): boolean {

    let originalMaterial = this.usedEmergencyMaterialsList.find(e => e.id === em.id);
    return originalMaterial.quantityUsed !== em.quantityUsed;
  }


  public onDeleteEmergencyMaterialClicked(emergencyMaterial: EmergencyMaterial, event: MouseEvent) {

    event.preventDefault();
    event.stopPropagation();

    this.client.remove(emergencyMaterial.id).subscribe(d => {
      if (d) {
        this.toastr.success("Промяната беше Успешно запазена", "Успешно Запазване", {
          timeOut: 3000,
        });
        const index = this._usedEmergencyMaterialsList.findIndex(e => e.id === emergencyMaterial.id);
        if (index > -1) {
          this._usedEmergencyMaterialsList.splice(index, 1);
          this._usedEmergencyMaterialsList = this._usedEmergencyMaterialsList.slice();
          this._availableMaterialsList.push(emergencyMaterial.material);

          this.emergencyMaterialDeleted.emit(emergencyMaterial);
          this.emergencyMaterialsUpdated.emit(this._usedEmergencyMaterialsList);

          this.changeDetectorRef.detectChanges();
        }
      }
      else {
        this.toastr.error("Възникна Грешка при запазването", "Грешка", {
          timeOut: 3000,
        });
      }

    });
  }


  public onSaveChanges(emergencyMaterial: EmergencyMaterial, event: MouseEvent) {

    event.preventDefault();
    event.stopPropagation();

    if (emergencyMaterial.quantityUsed <= 0) {
      this.toastr.error("Моля, изберете правилно количество", "Грешка", {
        timeOut: 3000,
      });
      return;
    }


    if (!emergencyMaterial.id) {

      this.toastr.success("Промяната беше Успешно запазена", "Успешно Запазване", {
        timeOut: 3000,
      });

    }
    else {
      this.client.update(emergencyMaterial).subscribe(d => {
        if (d) {
          this.toastr.success("Промяната беше Успешно запазена", "Успешно Запазване", {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error("Възникна Грешка при запазването", "Грешка", {
            timeOut: 3000,
          });
        }

      })

    }


  }
}
